<div class="image-container" (click)="navigateToReport()">
  <img [src]="data.imageUrl" [alt]="data.title" />
</div>
